import { EMPTY_FILTERS } from "./useSiteList";
import type { SiteListFilters } from "./useSiteList";

/**
 * True when at least one filter (search excluded — checked separately by the caller)
 * differs from EMPTY_FILTERS.
 */
export function hasAppliedFilters(filters: SiteListFilters): boolean {
  return (Object.keys(EMPTY_FILTERS) as (keyof SiteListFilters)[]).some(
    (key) => key !== "search" && filters[key] !== EMPTY_FILTERS[key],
  );
}

/** Заголовок пустого состояния, когда фильтры и/или поиск заданы (docs/screens/SiteList.md «empty»). */
export const EMPTY_FILTERS_HEADING = "Ни один сайт не подходит под фильтры";

/** Заголовок пустого состояния, когда пул сайтов пуст (ни фильтры, ни поиск не заданы). */
export const EMPTY_POOL_HEADING = "В пуле нет сайтов";

/**
 * Пул пуст (docs/screens/SiteList.md «empty»): ни фильтры, ни поиск не заданы —
 * сайты ещё не импортированы, а не отфильтрованы до нуля.
 */
export function emptyPoolExplanation(): string {
  return "В пуле нет ни одного сайта — сайты ещё не импортированы. Добавьте сайты списком.";
}

/**
 * Пояснение пустого состояния под фильтрами и/или поиском (скетч SiteList.Empty.html):
 * под какие именно условия не попал ни один сайт. Поисковый запрос называется в
 * тексте, потому что именно он чаще всего и сужает выдачу до нуля.
 */
export function emptyFiltersExplanation(search: string): string {
  const trimmedSearch = search.trim();
  const conditions =
    trimmedSearch === "" ? "текущие фильтры" : `текущие фильтры и поиск «${trimmedSearch}»`;
  return `Под ${conditions} не попал ни один сайт пула. Снимите часть фильтров или добавьте сайты списком.`;
}

export interface EmptyStateCopy {
  heading: string;
  explanation: string;
}

/** Заголовок и пояснение вместе, ветка «под фильтры» (docs/screens/SiteList.md «empty»). */
export function emptyFiltersState(search: string): EmptyStateCopy {
  return { heading: EMPTY_FILTERS_HEADING, explanation: emptyFiltersExplanation(search) };
}

/** Заголовок и пояснение вместе, ветка «пул пуст» (docs/screens/SiteList.md «empty»). */
export function emptyPoolState(): EmptyStateCopy {
  return { heading: EMPTY_POOL_HEADING, explanation: emptyPoolExplanation() };
}
